import {
	Activity,
	DefineActivityRequest,
	ProcessBuilderPage,
	Variable,
} from '@/scripts/types/generated';
import {Page} from '@inertiajs/core';

const activities = ref<Activity[]>();
const isLoading = ref<boolean>(false);

export const useActivities = () => {
	const {getAutomationVariables} = useAutomations();

	const refreshActivities = (page: Page<ProcessBuilderPage>) => {
		activities.value = page.props.activities;
	};

	const initActivities = async () => {
		while (isLoading.value) {
			await new Promise((resolve) => setTimeout(resolve, 100));
		}

		if (activities.value) return;

		isLoading.value = true;
		const page = await sendReloadRequest<ProcessBuilderPage>([
			'activities',
		]);
		refreshActivities(page);
		isLoading.value = false;
	};

	const createActivity = async (
		request: DefineActivityRequest
	): Promise<Activity> => {
		// TODO have a look into unhandled error some day
		const page = await sendCreateRequest<ProcessBuilderPage>(
			route('tenant.activities.store'),
			request,
			['activities']
		);

		return new Promise<Activity>((resolve) => {
			refreshActivities(page);
			const newActivity = activities.value.find(
				(activity) => activity.name === request.name
			);
			resolve(newActivity);
		});
	};

	const deleteActivity = async (slug: string): Promise<void> => {
		const page = await sendDeleteRequest<ProcessBuilderPage>(
			route('tenant.activities.destroy', {
				activity: slug,
			}),
			['activities']
		);

		return new Promise<void>((resolve) => {
			refreshActivities(page);
			resolve();
		});
	};

	const getActivity = async (uuid: string): Promise<Activity> => {
		if (!activities.value) {
			await initActivities();
		}

		return activities.value.find(
			(activity) => activity.versionUuid === uuid
		);
	};

	const getActivityVariables = async (
		activity: Activity
	): Promise<Variable[]> => {
		const variables: Variable[] = [];

		for (const automation of activity.automations) {
			variables.push(...(await getAutomationVariables(automation)));
		}

		return variables;
	};

	const setActivities = (newActivities: Activity[]) => {
		activities.value = newActivities;
	};

	return {
		activities,
		initActivities,
		createActivity,
		deleteActivity,
		getActivity,
		getActivityVariables,
		setActivities,
	};
};
